








var jspb=require('google-protobuf');
var goog=jspb;
var global=Function('return this')();

goog.exportSymbol('proto.mti.store.ram.RamStatus',null,global);











proto.mti.store.ram.RamStatus=function(opt_data){
jspb.Message.initialize(this,opt_data,0,-1,null,null);
};
goog.inherits(proto.mti.store.ram.RamStatus,jspb.Message);
if(goog.DEBUG&&!COMPILED){
proto.mti.store.ram.RamStatus.displayName='proto.mti.store.ram.RamStatus';
}


if(jspb.Message.GENERATE_TO_OBJECT){










proto.mti.store.ram.RamStatus.prototype.toObject=function(opt_includeInstance){
return proto.mti.store.ram.RamStatus.toObject(opt_includeInstance,this);
};











proto.mti.store.ram.RamStatus.toObject=function(includeInstance,msg){
var f,obj={
serialNumber:jspb.Message.getFieldWithDefault(msg,1,""),
batteryLevel:jspb.Message.getFieldWithDefault(msg,2,0),
lostCommunication:jspb.Message.getFieldWithDefault(msg,3,false),
identifying:jspb.Message.getFieldWithDefault(msg,4,false),
charging:jspb.Message.getFieldWithDefault(msg,5,false),
powered:jspb.Message.getFieldWithDefault(msg,6,false),
keyInserted:jspb.Message.getFieldWithDefault(msg,7,false),
keySerialNumber:jspb.Message.getFieldWithDefault(msg,8,""),
model:jspb.Message.getFieldWithDefault(msg,9,""),
hardwareVersion:jspb.Message.getFieldWithDefault(msg,10,""),
firmwareVersion:jspb.Message.getFieldWithDefault(msg,11,"")};


if(includeInstance){
obj.$jspbMessageInstance=msg;
}
return obj;
};
}







proto.mti.store.ram.RamStatus.deserializeBinary=function(bytes){
var reader=new jspb.BinaryReader(bytes);
var msg=new proto.mti.store.ram.RamStatus();
return proto.mti.store.ram.RamStatus.deserializeBinaryFromReader(msg,reader);
};









proto.mti.store.ram.RamStatus.deserializeBinaryFromReader=function(msg,reader){
while(reader.nextField()){
if(reader.isEndGroup()){
break;
}
var field=reader.getFieldNumber();
switch(field){
case 1:
var value=reader.readString();
msg.setSerialNumber(value);
break;
case 2:
var value=reader.readUint32();
msg.setBatteryLevel(value);
break;
case 3:
var value=reader.readBool();
msg.setLostCommunication(value);
break;
case 4:
var value=reader.readBool();
msg.setIdentifying(value);
break;
case 5:
var value=reader.readBool();
msg.setCharging(value);
break;
case 6:
var value=reader.readBool();
msg.setPowered(value);
break;
case 7:
var value=reader.readBool();
msg.setKeyInserted(value);
break;
case 8:
var value=reader.readString();
msg.setKeySerialNumber(value);
break;
case 9:
var value=reader.readString();
msg.setModel(value);
break;
case 10:
var value=reader.readString();
msg.setHardwareVersion(value);
break;
case 11:
var value=reader.readString();
msg.setFirmwareVersion(value);
break;
default:
reader.skipField();
break;}

}
return msg;
};






proto.mti.store.ram.RamStatus.prototype.serializeBinary=function(){
var writer=new jspb.BinaryWriter();
proto.mti.store.ram.RamStatus.serializeBinaryToWriter(this,writer);
return writer.getResultBuffer();
};









proto.mti.store.ram.RamStatus.serializeBinaryToWriter=function(message,writer){
var f=undefined;
f=message.getSerialNumber();
if(f.length>0){
writer.writeString(
1,
f);

}
f=message.getBatteryLevel();
if(f!==0){
writer.writeUint32(
2,
f);

}
f=message.getLostCommunication();
if(f){
writer.writeBool(
3,
f);

}
f=message.getIdentifying();
if(f){
writer.writeBool(
4,
f);

}
f=message.getCharging();
if(f){
writer.writeBool(
5,
f);

}
f=message.getPowered();
if(f){
writer.writeBool(
6,
f);

}
f=message.getKeyInserted();
if(f){
writer.writeBool(
7,
f);

}
f=message.getKeySerialNumber();
if(f.length>0){
writer.writeString(
8,
f);

}
f=message.getModel();
if(f.length>0){
writer.writeString(
9,
f);

}
f=message.getHardwareVersion();
if(f.length>0){
writer.writeString(
10,
f);

}
f=message.getFirmwareVersion();
if(f.length>0){
writer.writeString(
11,
f);

}
};






proto.mti.store.ram.RamStatus.prototype.getSerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,1,"");
};



proto.mti.store.ram.RamStatus.prototype.setSerialNumber=function(value){
jspb.Message.setProto3StringField(this,1,value);
};






proto.mti.store.ram.RamStatus.prototype.getBatteryLevel=function(){
return jspb.Message.getFieldWithDefault(this,2,0);
};



proto.mti.store.ram.RamStatus.prototype.setBatteryLevel=function(value){
jspb.Message.setProto3IntField(this,2,value);
};








proto.mti.store.ram.RamStatus.prototype.getLostCommunication=function(){
return jspb.Message.getFieldWithDefault(this,3,false);
};



proto.mti.store.ram.RamStatus.prototype.setLostCommunication=function(value){
jspb.Message.setProto3BooleanField(this,3,value);
};








proto.mti.store.ram.RamStatus.prototype.getIdentifying=function(){
return jspb.Message.getFieldWithDefault(this,4,false);
};



proto.mti.store.ram.RamStatus.prototype.setIdentifying=function(value){
jspb.Message.setProto3BooleanField(this,4,value);
};








proto.mti.store.ram.RamStatus.prototype.getCharging=function(){
return jspb.Message.getFieldWithDefault(this,5,false);
};



proto.mti.store.ram.RamStatus.prototype.setCharging=function(value){
jspb.Message.setProto3BooleanField(this,5,value);
};








proto.mti.store.ram.RamStatus.prototype.getPowered=function(){
return jspb.Message.getFieldWithDefault(this,6,false);
};



proto.mti.store.ram.RamStatus.prototype.setPowered=function(value){
jspb.Message.setProto3BooleanField(this,6,value);
};








proto.mti.store.ram.RamStatus.prototype.getKeyInserted=function(){
return jspb.Message.getFieldWithDefault(this,7,false);
};



proto.mti.store.ram.RamStatus.prototype.setKeyInserted=function(value){
jspb.Message.setProto3BooleanField(this,7,value);
};






proto.mti.store.ram.RamStatus.prototype.getKeySerialNumber=function(){
return jspb.Message.getFieldWithDefault(this,8,"");
};



proto.mti.store.ram.RamStatus.prototype.setKeySerialNumber=function(value){
jspb.Message.setProto3StringField(this,8,value);
};






proto.mti.store.ram.RamStatus.prototype.getModel=function(){
return jspb.Message.getFieldWithDefault(this,9,"");
};



proto.mti.store.ram.RamStatus.prototype.setModel=function(value){
jspb.Message.setProto3StringField(this,9,value);
};






proto.mti.store.ram.RamStatus.prototype.getHardwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,10,"");
};



proto.mti.store.ram.RamStatus.prototype.setHardwareVersion=function(value){
jspb.Message.setProto3StringField(this,10,value);
};






proto.mti.store.ram.RamStatus.prototype.getFirmwareVersion=function(){
return jspb.Message.getFieldWithDefault(this,11,"");
};



proto.mti.store.ram.RamStatus.prototype.setFirmwareVersion=function(value){
jspb.Message.setProto3StringField(this,11,value);
};


goog.object.extend(exports,proto.mti.store.ram);